// Central data-testid registry (kebab-case)
export const TID = {
  // Marketing / public
  navLogo: "nav-brand-logo",
  navLogin: "nav-login-link",
  navRequestDemo: "nav-request-demo",
  heroCtaInfluencer: "hero-cta-register-influencer",
  heroCtaEnterprise: "hero-cta-request-demo",
  benefitCard: (k) => `benefit-card-${k}`,
  demoForm: "demo-form",
  demoFormSubmit: "demo-form-submit",

  // Auth — password (DOM data-testid selectors only; these are NOT credentials)
  loginForm: "login-form",
  loginTabPassword: "login-tab-password",
  loginTabOtp: "login-tab-otp",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",

  // Auth — OTP
  otpEmailInput: "otp-email-input",
  otpMobileInput: "otp-mobile-input",
  otpRequestBtn: "otp-request-button",
  otpEmailCodeInput: "otp-email-code-input",
  otpPhoneCodeInput: "otp-phone-code-input",
  otpVerifyBtn: "otp-verify-button",

  // Signup
  signupLegalName: "signup-legal-name",
  signupCompany: "signup-company",
  signupType: "signup-type-select",
  signupCountry: "signup-country-select",
  signupSubmit: "signup-submit-button",

  // Shell
  sidebar: "app-sidebar",
  sidebarLink: (k) => `sidebar-link-${k}`,
  topbarUser: "topbar-user-menu",
  topbarLogout: "topbar-logout",
  topbarNotifications: "topbar-notifications",

  // Dashboards
  kpi: (k) => `kpi-${k}`,

  // Orders
  createOrderBtn: "create-order-btn",
  orderRow: (id) => `order-row-${id}`,
  orderForm: "order-form",
  orderSubmit: "order-submit-btn",
  inviteInfluencerBtn: (id) => `invite-influencer-${id}`,
  issuePoBtn: (id) => `issue-po-${id}`,

  // Influencer / KYS
  influencerRow: (id) => `influencer-row-${id}`,
  kysStep: (s) => `kys-step-${s}`,
  kysInput: (s) => `kys-input-${s}`,
  kysVerifyBtn: (s) => `kys-verify-${s}`,
  kysSubmitReview: "kys-submit-review",
  kysApproveBtn: (id) => `kys-approve-${id}`,

  // Deliverables
  deliverableUrlInput: "deliverable-url-input",
  deliverableCaptionInput: "deliverable-caption-input",
  deliverableSubmitBtn: "deliverable-submit-btn",
  deliverableFileInput: "deliverable-file-input",
  deliverableApprove: (id) => `deliverable-approve-${id}`,
  deliverableReject: (id) => `deliverable-reject-${id}`,

  // Payments
  advanceRequestBtn: "advance-request-btn",
  advancePct: (p) => `advance-pct-${p}`,
  finalRequestBtn: "final-request-btn",
  paymentApprove: (id) => `payment-approve-${id}`,
  paymentDisburse: (id) => `payment-disburse-${id}`,

  // Admin
  saveConfigBtn: "save-config-btn",
  tenantLogoInput: "tenant-logo-input",

  // Notifications
  notificationRow: (id) => `notification-${id}`,
};

export default TID;
